export { GLOBAL_NAMESPACE, SELF, STATIC } from "./ast/core/Constant.js";
export { PHP_RESERVED_KEYWORDS } from "./constants.js";
export { BasePhpCustomConfigSchema } from "./custom-config/BasePhpCustomConfigSchema.js";
export * as php from "./php.js";
export { getSafeClassName } from "./utils.js";
